import { FightAction } from '../models/fight';
import { belongsToFight, belongsToFightStrict } from '../utils/legacyId';

/** Agregados que só existem no outcome; não entram no log de actions. */
const keysToIgnore = ['significantStrike', 'totalStrike'];

export interface ActionReducer {
  type: string;
  payload?: FightAction;
  init?: Array<FightAction>;
}

/**
 * Reducer da lista de actions, isolado do provider para ser testável.
 * @param fight - a luta aberta, usada pelo guard de pertencimento
 */
export function actionsReducer(
  fight: { id?: string; legacyId?: number | null },
  state: FightAction[],
  action: ActionReducer,
): FightAction[] {
  // `reset`/`remove` destroem estado: guard fail-closed. Backstop dos
  // handlers, que já filtram antes de qualquer efeito colateral.
  const guard = ['reset', 'remove'].includes(action.type)
    ? belongsToFightStrict
    : belongsToFight;

  if (!guard(action.payload, fight)) return state;
  const hasAction = state.find(
    (stateAction) => stateAction._id === action.payload?._id,
  );

  switch (action.type) {
    case 'fetch':
      return action.init || state;
    case 'add':
      if (action.payload?.name && keysToIgnore.includes(action.payload?.name))
        return state;

      return action.payload && !hasAction ? [action.payload, ...state] : state;
    case 'update':
      // Substitui no lugar, preservando a ordem do log. O servidor emite
      // `updated` ao editar uma action — antes ninguém escutava, e a lista
      // ficava com a versão antiga até um refetch.
      return hasAction && action.payload
        ? state.map((stateAction) =>
            stateAction._id === action.payload?._id
              ? (action.payload as FightAction)
              : stateAction,
          )
        : state;
    case 'remove':
      return hasAction
        ? state.filter((stateAction) => stateAction._id !== action.payload?._id)
        : state;
    case 'reset':
      return [];
    default:
      return state;
  }
}
